<template>
  <section class="section__dominos">
    <!-- <FloatingCaseStudy :caseColor="caseColor" :caseText="caseText"></FloatingCaseStudy> -->

    <div class="section__dominos--bg">
      <div class="section__dominos--scene">
        <img
          class="small-leaves apple lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/apple_Sk-md-RQP4.png"
          data-src="https://ik.imagekit.io/intervi/apple_Sk-md-RQP4.png"
          data-srcset="https://ik.imagekit.io/intervi/apple_2x_HJ7M_b0QvN.png 2x"
          alt="apple"
        />
        <img
          class="small-leaves leaf3 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/leaf3_r1zzOZAXPN.png"
          data-src="https://ik.imagekit.io/intervi/leaf3_r1zzOZAXPN.png"
          data-srcset="https://ik.imagekit.io/intervi/leaf3_2x_S1mm_b07vE.png 2x"
          alt="leaf3"
        />
        <img
          class="small-leaves leaf4 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/leaf4_ByZzOWAXD4.png"
          data-src="https://ik.imagekit.io/intervi/leaf4_ByZzOWAXD4.png"
          data-srcset="https://ik.imagekit.io/intervi/leaf4_2x_Sy7dbAmDN.png 2x"
          alt="leaf4"
        />
        <img
          class="small-leaves leaf5 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/leaf5_SJEz_ZR7vN.png"
          data-src="https://ik.imagekit.io/intervi/leaf5_SJEz_ZR7vN.png"
          data-srcset="https://ik.imagekit.io/intervi/leaf5_2x_ByZXdZAmP4.png 2x"
          alt="leaf5"
        />
        <div id="big-leaves-box">
          <img
            class="big-leaves leaves1 lazyload"
            src="https://ik.imagekit.io/intervi/tr:bl-7/pizza_listki_H14ubAQPV.png"
            data-src="https://ik.imagekit.io/intervi/pizza_listki_H14ubAQPV.png"
            alt="listki"
          />
          <img
            class="big-leaves leaves2 lazyload"
            src="https://ik.imagekit.io/intervi/tr:bl-7/pizza_listki_H14ubAQPV.png"
            data-src="https://ik.imagekit.io/intervi/pizza_listki_H14ubAQPV.png"
            alt="listki"
          />
        </div>
        <div id="phone-box">
          <img
            id="phone"
            class="pizza-iphone lazyload"
            src="https://ik.imagekit.io/intervi/tr:w-2048,bl-7/iphone-pizza_ryGQdZRQwV.png"
            data-src="https://ik.imagekit.io/intervi/tr:w-2048/iphone-pizza_ryGQdZRQwV.png"
            alt="iphone"
          />
        </div>
        <img
          class="small-leaves leaf1 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/leaf1_B1lzOWAQv4.png"
          data-src="https://ik.imagekit.io/intervi/leaf1_B1lzOWAQv4.png"
          data-srcset="https://ik.imagekit.io/intervi/leaf1_2x_SklQO-C7DV.png 2x"
          alt="leaf1"
        />
        <img
          class="small-leaves leaf2 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/leaf2_Sybz_bRQwN.png"
          data-src="https://ik.imagekit.io/intervi/leaf2_Sybz_bRQwN.png"
          data-srcset="https://ik.imagekit.io/intervi/leaf2_2x_rJW-d-07PE.png 2x"
          alt="leaf2"
        />
      </div>
    </div>
  </section>
</template>

<script>
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";

export default {
  name: "ComponentDominos",
  data() {
    return {};
  },
  props: ["showChild", "activeSection"],
  mounted: function() {
    this.movePhone();
    this.moveBigLeaves();
    this.moveSmallLeaves();
  },
  methods: {
    movePhone: function() {
      $(document).mousemove(function(event) {
        $("#phone").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -25,
            ease: Power1.easeOut
          });
        });
      });
    },

    moveBigLeaves: function() {
      $(document).mousemove(function(event) {
        $(".big-leaves").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * Math.random() * 20,
            y: Math.random() * 5,
            ease: Power1.easeOut
          });
        });
      });
    },

    moveSmallLeaves: function() {
      $(document).mousemove(function(event) {
        $(".small-leaves").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * Math.random() * 30,
            y: Math.random() * 5,
            ease: Power1.easeOut
          });
        });
      });
    }
  },
  components: {
    FloatingSocials: FloatingSocials
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentPizzaBox.vue